import axios from "axios";

export default {
  state: {
    availableLanguages: [],
    selectedLanguage: null,
  },

  getters: {
    selectedLanguageCode(state) {
      if (state.selectedLanguage) {
        return state.selectedLanguage.name;
      }
      return null;
    },
    workLanguageQueryParams(state, getters) {
      if (getters.selectedLanguageCode !== null) {
        return {
          lang: getters.selectedLanguageCode,
        };
      }
      return {};
    },
  },

  actions: {
    async fetchAvailableLanguages({ commit, dispatch }, { worksetUUID }) {
      try {
        let response = await axios.get(
          `/api/hits/workhit/stats/${worksetUUID}/lang`
        );
        commit("setAvailableLanguages", { languages: response.data });
      } catch (error) {
        dispatch(
          "showSnackbar",
          { content: "Error obtaining list of languages: " + error },
          { root: true }
        );
      }
    },
    changeSelectedLanguage({ commit }, langSpec) {
      commit("setSelectedLanguage", langSpec);
    },
  },

  mutations: {
    setAvailableLanguages(state, { languages }) {
      state.availableLanguages = languages;
    },
    setSelectedLanguage(state, langSpec) {
      state.selectedLanguage = langSpec;
    },
  },
};
